import React, { useEffect, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import {
  Pagination,
  Datagrid,
  DateField,
  List,
  NumberField,
  TextField,
  useListContext,
  FunctionField,
  ReferenceField,
} from "react-admin";
import {
  Box,
  Button,
  TextField as MuiTextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Typography } from "@mui/material";

import CustomPagination from "../../../Components/CustomPagination";

const ConditionalDatagrid = () => {
  const { isLoading, data, total } = useListContext();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  if (isLoading) return null;
  if (!total || total === 0) return <EmptyMessage />;

  return (
    <Box style={{ width: "100%", overflowX: "auto" }}>
      <Box style={{ width: "100%", position: isSmallScreen ? "absolute" : "relative" }}>
        <Datagrid
          bulkActionButtons={false}
          sx={{
            overflowX: "auto",
            overflowY: "hidden",
            width: "100%",
            maxHeight: "100%",
            "& .RaDatagrid-table": {
              width: "100%",
            },
          }}
        >
          <ReferenceField
            source="userId.id"
            reference="users"
            label="User Name"
            emptyText="Missing User"
            link={false}
            sortBy="userId.username"
          >
            <TextField source="username" />
          </ReferenceField>

          <FunctionField
            label="Game Name"
            render={(record) => <GameNameField record={record} />}
          />

          <NumberField
            source="beforeBalance"
            label="Opening Balance"
            options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          />
          <NumberField
            source="betAmount"
            label="Bet Amount"
            options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          />
          <NumberField
            source="winloseAmount"
            label="Win Amount"
            options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          />
          <NumberField
            source="afterBalance"
            label="Closing Balance"
            options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          />
          <DateField source="createdAt" label="Register date" showTime />
        </Datagrid>
      </Box>
    </Box>
  );
};


const GameNameField = ({ record }) => {
  if (!record) return null;

  if (record.gameName) {
    return <TextField source="gameName" label="Game Name" record={record} />;
  }

  return (
    <ReferenceField
      source="gameId.id"
      reference="GameRtp"
      label="Game Name"
      emptyText="Missing Game"
      link={false}
      sortBy="gameId.name"
      record={record}
    >
      <TextField source="name" />
    </ReferenceField>
  );
};
const CustomFilter = () => {
    const [searchParams]  = useSearchParams(); 
    const defaultUsername = searchParams.get("username");
    const { setFilters } = useListContext();
    const [username, setUsername] = useState(defaultUsername);
    const [gameNameFilter, setGameNameFilter] = useState("");
    const today = new Date().toISOString().split("T")[0];
    const oneMonthAgo = new Date();
    oneMonthAgo.setDate(oneMonthAgo.getDate() - 1);
    const defaultStartDate = oneMonthAgo.toISOString().split("T")[0];
  
    const [startDate, setStartDate] = useState(defaultStartDate);
    const [endDate, setEndDate] = useState(today);
  
    useEffect(() => {
      handleApply();
    }, [defaultUsername]); 

    const handleApply = () => {
      const filters = {};
      if (username?.trim()) filters.username = username;
      if (gameNameFilter?.trim()) filters.gameName = gameNameFilter;
      if (startDate) filters.startDate = startDate;
      if (endDate) filters.endDate = endDate;
      setFilters(filters, {});
    };
  
    const handleClear = () => {
      setUsername(defaultUsername || "");
      setGameNameFilter("");
      setStartDate("");
      setEndDate("");
        const filters = {};
  if (username?.trim()) filters.username = username;
  setFilters(filters, {});
    };
  
    return (
      <Box display="flex" alignItems="center" gap={2}>
        {/* <MuiTextField
          size="small"
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter Username"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleApply();
            }
          }}
        /> */}
  
        <MuiTextField
          size="small"
          variant="outlined"
          value={gameNameFilter}
          onChange={(e) => setGameNameFilter(e.target.value)}
          placeholder="Enter Game Name"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleApply();
            }
          }}
        />
  
        <MuiTextField
          size="small"
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={startDate}
          onChange={(e) => {
            const newStart = e.target.value;
            setStartDate(newStart);
            if (endDate && newStart > endDate) {
              setEndDate("");
            }
          }}
          inputProps={{ max: today }}
        />
  
        <MuiTextField
          size="small"
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          inputProps={{
            min: startDate || undefined,
            max: today,
          }}
        />
  
        <Button
          variant="contained"
          sx={{
            background: "#FFC107",
            color: "#0A0A0A",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#FFA000",
            },
          }}
          onClick={handleApply}
        >
          Apply
        </Button>
  
        <Button
          variant="outlined"
          sx={{
            outline: "1px solid #FFC107",
            color: "white",
            textTransform: "none",
          }}
          onClick={handleClear}
        >
          Clear
        </Button>
      </Box>
    );
  };
  
  
const PostPagination = () => {
  const { total, page, perPage, setPage, setPerPage } = useListContext();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100% !important",
        margin: "16px 0px",
      }}
    >
      <CustomPagination
        page={page}
        perPage={perPage}
        total={total}
        setPage={setPage}
        setPerPage={setPerPage}
        componentPage="allgames"
      />
    </Box>
  );
};


const EmptyMessage = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "200px",
    }}
  >    <Typography variant="h6" color="textSecondary">
        No game records available yet
    </Typography>
  </Box>
);

export const GamesData = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [searchParams]  = useSearchParams(); 
  const defaultUsername = searchParams.get("username");
  return (
    <Box
      sx={{
        mt: 2,
        backgroundColor: "#242424",
        borderRadius: 2,
        boxShadow: "none !important",
        padding: isSmallScreen ? { xs: 0, sm: 0 } : { xs: 1.5, sm: 2 },
      }}
    >
      <List
        title="All Game Records"
        resource="userCoinAllUser"
        filters={<CustomFilter />}
        filter={{ username:defaultUsername}}
        sort={{ field: "createdAt", order: "DESC" }}
        actions={null}
        perPage={100}
        pagination={<PostPagination />}
        sx={{
          "& .RaList-actions": {
            flexWrap: "nowrap",
          },
          "& .RaFilterFormInput-spacer": { display: "none" },
        }}
          empty={<EmptyMessage />}   // 👈 add this
      >
        <Box style={{ width: "100%", overflowX: "auto" }}>
          <Box style={{ width: "100%", position: isSmallScreen ? "absolute" : "relative" }}>
          <ConditionalDatagrid />
          </Box>
        </Box>
      </List>
    </Box>
  );
};
